module.exports = __webpack_public_path__ + "img/Silver Elite Master.28a76c95.png";